import api from './api';

const radiologyMasterConfigService = {
  /**
   * Fetch Master Configuration Dashboard statistics & progress
   */
  async getDashboard() {
    const res = await api.get('/radiology/master-config/dashboard');
    return res.data;
  },

  /**
   * Fetch smart phrases
   */
  async getSmartPhrases(category = '') {
    const params = category ? { category } : {};
    const res = await api.get('/radiology/master-config/smart-phrases', { params });
    return res.data;
  },

  /**
   * Create smart phrase
   */
  async createSmartPhrase(payload) {
    const res = await api.post('/radiology/master-config/smart-phrases', payload);
    return res.data;
  },

  /**
   * Update smart phrase
   */
  async updateSmartPhrase(id, payload) {
    const res = await api.put(`/radiology/master-config/smart-phrases/${id}`, payload);
    return res.data;
  },

  /**
   * Delete smart phrase
   */
  async deleteSmartPhrase(id) {
    const res = await api.delete(`/radiology/master-config/smart-phrases/${id}`);
    return res.data;
  },

  /**
   * Get version history snapshots for a template
   */
  async getTemplateVersions(templateId) {
    const res = await api.get(`/radiology/master-config/templates/${templateId}/versions`);
    return res.data;
  },

  /**
   * Restore a historical version snapshot
   */
  async restoreTemplateVersion(templateId, versionId, changeReason = '') {
    const res = await api.post(`/radiology/master-config/templates/${templateId}/versions/${versionId}/restore`, {
      changeReason
    });
    return res.data;
  }
};

export default radiologyMasterConfigService;
